import { memo, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { setOpen } from '../../Redux/Services/headerSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall } from '../CommonComponents/CustomHooks';
import { InputGroupBox } from '../CommonComponents/InputBox';

const Sidebar2 = () => {
    const [menus, setMenus] = useState([]);
    const [activeParent, setActiveParent] = useState(null);
    const dispatch = useDispatch();
    const open = useSelector((state) => state.header.open);
    const [searchingText, setSearchingText] = useState('');
    const [searchingData, setSearchingData] = useState([]);
    const getSidebar = async () => {
        try {
            const res = await ApiCall(`/api/ClientUser/GetMenu`, { SearchText: "" });
            if (res.status === 'SUCCESS') {
                setMenus(res.getMenu);
            } else if (res.status === "ERROR") {
                setMenus([]);
            } else if (res.status === 'EXPIRED') {
                await NotificationSound(res.status, res.message, res.focus);
            }
        } catch (error) {
            console.error('Error fetching sidebar menu:', error);
            setMenus([]);
        }
    };
    const debounce = (func, delay) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    };

    const fetchSearchResults = async (searchValue) => {
        if (!searchValue) {
            setSearchingData([]);
            return;
        }

        const res = await ApiCall('/api/ClientUser/GetSearchMenu', { SearchText: searchValue });

        if (res && res.status === "SUCCESS") {
            setSearchingData(res.getSearchText);
        } else {
            setSearchingData([]);
        }
    };

    const debouncedApiCall = useMemo(() => debounce(fetchSearchResults, 500), []);
    const handleInputChange = (value) => {
        setSearchingText(value);
        debouncedApiCall(value);
    };


    const location = useLocation();

    const isParentActive = (menu) => {
        return menu.getSubMenu?.some(
            (sub) => `/${sub.pageUrl}` === location.pathname
        );
    };

    useEffect(() => {
        function handleresize() {
            dispatch(setOpen(window.innerWidth >= 1200));
        }
        handleresize();
        window.addEventListener("resize", handleresize);
        return () => window.removeEventListener("resize", handleresize);
    }, []);

    useEffect(() => {
        getSidebar();
    }, []);

    return (
        <>
            <aside
                id="sidebar"
                className="sidebar"
                style={open ? {} : { left: "-250px" }}
            >
                {/* Logo */}
                <div className="sidebar-logo-wrap">
                    <Link to="/" className="logo-default">
                        <img src="assets/img/patliputra_logo.png" alt="logo" />
                    </Link>
                </div>
                <div className="positon-relative m-1 ">
                    <InputGroupBox
                        divclassname='col-lg-12 col-md-12 col-sm-12 pe-0 pb-0 mb-0 '
                        value={searchingText}
                        maxLength='50'
                        id='txtSearch'
                        onChange={(e) => handleInputChange(e.target.value)}
                        placeholder="Search"
                        startIcon="fa-solid fa-magnifying-glass"
                    />
                </div>
                {searchingData.length > 0 && (
                    <div
                        className="sidebar-search-results"
                        style={{ maxHeight: '300px', overflowY: 'auto' }}
                    >
                        <ul
                            id={`searchMenu`}
                            className={`nav-content sidebar-submenu`}
                            data-bs-parent="#sidebar-nav"
                        >
                            {searchingData?.map((subMenu, i) => (
                                <li
                                    key={i}
                                    onClick={() =>
                                        localStorage.setItem('ID', subMenu?.mpageID)
                                    }
                                >
                                    <NavLink
                                        to={`/${subMenu?.pageUrl}`}
                                        id={subMenu?.pageID}
                                        onClick={() => {
                                            setSearchingText('');
                                            setSearchingData([]);
                                        }}
                                    >
                                        <span>{subMenu?.menuText?.trim()}</span>
                                    </NavLink>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
                <ul className="sidebar-nav" id="sidebar-nav">
                    {menus && menus?.map((menu, index) => (
                        <li className="nav-item" key={index}>
                            {menu.getSubMenu ? (
                                <>
                                    <div
                                        className={`nav-link ${isParentActive(menu) ? "active-parent" : ""} cursor-pointer`}
                                        data-bs-target={`#${menu.menuText.replaceAll(' ', '')}`}
                                        data-bs-toggle="collapse"
                                        onClick={() =>
                                            setActiveParent(activeParent === index ? null : index)
                                        }
                                    >
                                        <i className={menu.cssClass} />
                                        <span>{menu.menuText}</span>
                                        <i className="bi bi-chevron-down ms-auto" />
                                    </div>
                                    <ul
                                        id={`${menu.menuText.replaceAll(' ', '')}`}
                                        className={`nav-content collapse sidebar-submenu ${menu.getSubMenu[0]?.mpageID === localStorage.getItem('ID')
                                            ? 'show'
                                            : ''
                                            }`}
                                        data-bs-parent="#sidebar-nav"
                                    >
                                        {menu.getSubMenu.map((subMenu, i) => (
                                            <li
                                                key={i}
                                                onClick={() =>
                                                    localStorage.setItem('ID', subMenu.mpageID)
                                                }
                                            >
                                                <NavLink
                                                    to={`/${subMenu.pageUrl}`}
                                                    id={subMenu.pageID}
                                                >
                                                    <span>{subMenu.menuText.trim()}</span>
                                                </NavLink>
                                            </li>
                                        ))}
                                    </ul>
                                </>
                            ) : (
                                <NavLink
                                    className="nav-link collapsed"
                                    to={`/${menu.pageUrl}`}
                                >
                                    <i className={menu.cssClass} />
                                    <span>{menu.menuText}</span>
                                </NavLink>
                            )}
                        </li>
                    ))}
                </ul>
            </aside>
        </>
    );
};

export default memo(Sidebar2);